import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SFSOptions } from '../../data-table/abstractdata.service';
import { User } from '../../models/user';
import { Pageable } from '../../models/pageable';
import { WorkflowDataService } from '../../data-table/workflow-data.service';
import { serializeUserRolesForRequest } from '../../utils/authorization.util';

@Injectable({ providedIn: 'root' })
export class AllUserService extends WorkflowDataService<User> {
  protected override get apiEndpoint(): string {
    return '/user';
  }

  override list(options: Partial<SFSOptions> = {}): Observable<Pageable<User>> {
    const params = this.getParams(options);
    return this.http.get<Pageable<User>>(`${this.baseUrl + this.apiEndpoint}/all`, { params });
  }

  override update(user: User): Observable<User> {
    const editUser = {
      firstName: user.given_name,
      lastName: user.family_name,
      email: user.email,
      organizationId: user.organization?.id,
      ...(user.roles !== undefined
        ? { roles: serializeUserRolesForRequest(user.roles) }
        : {}),
    };
    return this.http.put<User>(`${this.baseUrl + this.apiEndpoint}/${user.id}`, editUser);
  }

  lock(user: User): Observable<void> {
    return this.http.post<void>(`${this.baseUrl + this.apiEndpoint}/${user.id}/lock`, {});
  }

  unlock(user: User): Observable<void> {
    return this.http.post<void>(`${this.baseUrl + this.apiEndpoint}/${user.id}/unlock`, {});
  }

  resetPassword(user: User): Observable<void> {
    return this.http.post<void>(`${this.baseUrl + this.apiEndpoint}/${user.id}/reset-password`, {});
  }

  changePrimaryOrganization(userId: string, organizationId: string): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl + this.apiEndpoint}/${userId}/primary-organization`, {
      organizationId,
    });
  }
}
